/**
 * @enum {string}
 */
const DojoReportType = Object.freeze({
    BANKING: 'BANKING',
    END_OF_DAY: 'END_OF_DAY',
    X_BALANCE: 'X_BALANCE',
    Z_BALANCE: 'Z_BALANCE',
});

module.exports = DojoReportType;
